module.exports = __webpack_public_path__ + "img/bill.93faf1c3.png";